export default __webpack_public_path__ + "static/media/trade_hk_03.b7901994.png";